import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Ajuda from './views/Ajuda.vue'
import Dados from './views/Dados.vue'
import Extrato from './views/Extrato.vue'
import Vantagens from './views/Vantagens.vue'
import VantagensDetalhe from './views/VantagensDetalhe.vue'
import TelaNova from './views/TelaNova.vue'
import PoliticaPrivacidade from './views/PoliticaPrivacidade.vue'
import TermosUso from './views/TermosUso.vue'
import ExcluirConta from './views/ExcluirConta.vue'
import QRCode from './views/QRCode/QRCode.vue';
import QRCodeComprar from './views/QRCode/Comprar/Comprar.vue';
import QRCodeComprados from './views/QRCode/Comprados/Comprados.vue';
import QRCodePagamento from './views/QRCode/Pagamento/Pagamento.vue';
import QRCodeDetalhe from './views/QRCode/Detalhe/Detalhe.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '*', component: Home },
    {
      path: '/recarga',
      name: 'home',
      component: Home
    },
    {
      path: '/bilhete-especial',
      name: 'bilhete-especial',
      component: QRCode
    },
    {
      path: '/bilhete-especial/comprar',
      name: 'bilhete-especial-comprar',
      component: QRCodeComprar
    },
    {
      path: '/bilhete-especial/pagamento',
      name: 'bilhete-especial-pagamento',
      component: QRCodePagamento
    },
    {
      path: '/bilhete-especial/detalhe',
      name: 'bilhete-especial-detalhe',
      component: QRCodeDetalhe
    },
    {
      path: '/bilhete-especial/comprados',
      name: 'bilhete-especial-comprados',
      component: QRCodeComprados
    },
    {
      path: '/criarconta',
      name: 'conta',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/ajuda',
      name: 'ajuda',
      component: Ajuda
    },
    {
      path: '/faleconosco',
      name: 'faleconosco',
      component: Ajuda
    },
    {
      path: '/meugiro',
      name: 'dados',
      component: Dados
    },
    {
      path: '/extrato',
      name: 'extrato',
      component: Extrato
    },
    {
        path: '/retornopagamento',
        name: 'retornopagamento',
        component: TelaNova
    }
    ,{
      path: '/vantagens',
      name: 'vantagens',
      component: Vantagens
    },
    {
      path: '/vantagens/:slug',
      name: 'vantagens-detalhe',
      component: VantagensDetalhe
    },
    {
      path: '/politica-privacidade',
      name: 'politica-privacidade',
      component: PoliticaPrivacidade
    },
    {
      path: '/termos-de-uso',
      name: 'termos-de-uso',
      component: TermosUso
    },
    {
      path: '/excluir-conta',
      name: 'excluir-conta',
      component: ExcluirConta
    }
  ]
})
